<template>
  <div class="w-1/2 p-2 md:w-1/4 p-6" :class="room.background">
    <router-link
      :to="{ path: '/room/' + room.id, params: { id: room.id } }"
      class="text-white text-center text-xl"
      >{{ room.name }}</router-link
    >
  </div>
</template>

<script>
export default {
  name: "RoomItem",
  props: {
    room: {
      type: Object,
      required: true
    }
  }
};
</script>
